import classNames from 'classnames';
import * as React from 'react';

import { AboutPage } from '../pages/about-page';
import { CateringPage } from '../pages/catering-page';
import { HomePage } from '../pages/home-page/home-page';
import { MenuPage } from '../pages/menu-page/menu-page';
import { Page } from '../pages/page/page.container';

type Props = {
  open: boolean;
  selectedPage: number;
};

const pages = [HomePage, MenuPage, CateringPage, AboutPage];

export class PagesStack extends React.PureComponent<Props> {
  private getRank(index: number) {
    const { selectedPage } = this.props;

    return (index - selectedPage + pages.length + 3) % pages.length;
  }

  public render() {
    const { open } = this.props;

    return (
      <div className={classNames('pages-stack', { 'pages-stack--open': open })}>
        {
          pages.map((page, index) => (
            <Page key={index} rank={this.getRank(index)} index={index}>{React.createElement(page)}</Page>
          ))
        }
      </div>
    );
  }
}

/*
        <Route path="/" exact component={this.getPage(HomePage)} />
        <Route path="/menu" component={MenuPage} />
        <Route path="/catering" component={CateringPage} />
        <Route path="/about" component={AboutPage} />
 */
